import type { QueryClient } from '@tanstack/react-query';
import { elowenClient } from '../elowenClient';
import type { BrainConversationNotificationsUpdate } from '../types';
import { invalidateConversationLists } from './brain';

/** The write was accepted, but its list projections could not be refreshed. */
export class ConversationNotificationsRefreshError extends Error {
  constructor(cause: unknown) { super('Accepted notification preference could not be refreshed', { cause }); }
}

/** Write only against the viewer's confirmed revision; refresh all list projections after acceptance. */
export async function setConversationNotifications(qc: QueryClient, id: string, input: BrainConversationNotificationsUpdate) {
  const result = await elowenClient.brainSetConversationNotifications(id, input);
  try { await invalidateConversationLists(qc); }
  catch (cause) { throw new ConversationNotificationsRefreshError(cause); }
  return result;
}
